import React, { useState } from 'react';
import './Chatbot.css';

const Chatbot = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([
    { text: 'Hi! How can I help you today?', sender: 'bot' }
  ]);
  const [input, setInput] = useState('');

  const quickReplies = [
    'How do I register?',
    'Payment issues',
    'Event not showing',
    'Contact support'
  ];

  const handleSend = () => {
    if (!input.trim()) return;

    const userMessage = { text: input, sender: 'user' };
    setMessages(prev => [...prev, userMessage]);

    // Bot responses
    let botResponse = '';
    const lowerInput = input.toLowerCase();

    if (lowerInput.includes('register') || lowerInput.includes('sign up')) {
      botResponse = 'To register, click the "Register" button in the top right. Fill in your details with a valid email and password (min 8 characters).';
    } else if (lowerInput.includes('payment') || lowerInput.includes('pay')) {
      botResponse = 'For payment issues, please contact our support team at Operations@virtuosogenai.com. We process payments securely through Stripe.';
    } else if (lowerInput.includes('event') || lowerInput.includes('meeting')) {
      botResponse = 'Browse events by using the filters for country, locality, or topic. Click on any event to see details and join.';
    } else if (lowerInput.includes('contact') || lowerInput.includes('support') || lowerInput.includes('help')) {
      botResponse = 'For any support or assistance, email us at: Operations@virtuosogenai.com. We\'ll respond within 24 hours!';
    } else if (lowerInput.includes('price') || lowerInput.includes('cost')) {
      botResponse = 'Event prices vary by location and topic. You can see the price on each event listing. Payment is required to access the meeting link.';
    } else if (lowerInput.includes('refund')) {
      botResponse = 'For refund requests, please contact Operations@virtuosogenai.com with your event details and payment confirmation.';
    } else {
      botResponse = 'I\'m here to help! For detailed assistance, please email Operations@virtuosogenai.com or try one of the quick options below.';
    }

    setTimeout(() => {
      setMessages(prev => [...prev, { text: botResponse, sender: 'bot' }]);
    }, 500);

    setInput('');
  };

  const handleQuickReply = (reply) => {
    setInput(reply);
  };

  return (
    <>
      {/* Chatbot Toggle Button */}
      <button 
        className="chatbot-toggle"
        onClick={() => setIsOpen(!isOpen)}
        title="Chat with us"
      >
        {isOpen ? '✕' : '💬'}
      </button>

      {/* Chatbot Window */}
      {isOpen && (
        <div className="chatbot-window">
          <div className="chatbot-header">
            <h3>Support Chat</h3>
            <span style={{ fontSize: 12 }}>Operations@virtuosogenai.com</span>
          </div>

          <div className="chatbot-messages">
            {messages.map((msg, idx) => (
              <div key={idx} className={`message ${msg.sender}`}>
                {msg.text}
              </div>
            ))}
          </div>

          <div className="chatbot-quick-replies">
            {quickReplies.map((reply, idx) => (
              <button 
                key={idx} 
                className="quick-reply-btn"
                onClick={() => handleQuickReply(reply)}
              >
                {reply}
              </button>
            ))}
          </div>

          <div className="chatbot-input">
            <input
              type="text"
              placeholder="Type your message..."
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyPress={(e) => e.key === 'Enter' && handleSend()}
            />
            <button onClick={handleSend}>Send</button>
          </div>
        </div>
      )}
    </>
  );
};

export default Chatbot;
